import React from 'react';
import { Spin } from 'antd';
import classNames from 'classnames';
import './styles.less';

export const Loadable = ( { loading, children, fixed, ...spinProps } ) => {

    return (
        <Spin 
            spinning={ ( loading === true ) } 
            className={ classNames( { fixed } ) } 
            children={ children } { ...spinProps }
        /> 
    );
    
};